import { formatDate } from '@thoughtspot/date-format-util';
import { useTranslation } from '@thoughtspot/i18n';
import { useEffect, useMemo } from 'react';
import { useGetUserDetailsByIdWithUsersListLazyQuery } from "../../../../../services/user-group/user-group-service";
import { ActiveModal, getAuthTypeLabel, getStatusDisplayLabel, V2TranslationKeys, } from '../constants';
export const useUserDetails = ({ userId, activeModal, isClusterAdmin, orgNameMap, }) => {
    const { t } = useTranslation();
    const { data: raw, error, getUserById, } = useGetUserDetailsByIdWithUsersListLazyQuery([userId], userId);
    useEffect(() => {
        if (activeModal === ActiveModal.USER_DETAILS && userId) {
            getUserById();
        }
    }, [activeModal, userId]);
    const userDetailsProps = useMemo(() => {
        const details = raw?.getUserDetailById?.[0];
        const groups = (raw?.listUserGroupById ?? []).filter(Boolean);
        const displayName = details?.displayName ?? details?.header?.displayName ?? '';
        const email = details?.userContent?.userProperties?.mail ?? '';
        const status = details?.state ?? '';
        const created = details?.header?.created;
        const authType = details?.type ?? '';
        const metadataRows = [
            {
                label: t(V2TranslationKeys.USER_DETAILS_STATUS),
                value: getStatusDisplayLabel(status),
            },
            {
                label: t(V2TranslationKeys.USER_DETAILS_USER_SINCE),
                value: created ? formatDate(created, 'd MMMM yyyy') : '',
            },
            {
                label: t(V2TranslationKeys.USER_DETAILS_USER_TYPE),
                value: getAuthTypeLabel(authType),
            },
        ];
        const orgIds = details?.header?.orgIds ?? [];
        const orgNames = isClusterAdmin
            ? orgIds.map(id => orgNameMap[id]).filter(Boolean)
            : [];
        const listTitle = isClusterAdmin
            ? t(V2TranslationKeys.USER_DETAILS_ORGS)
            : t(V2TranslationKeys.USER_DETAILS_GROUPS);
        const listItems = isClusterAdmin
            ? orgNames.map(name => ({ key: name, label: name }))
            : groups.map((g) => ({
                key: g?.id,
                label: g?.displayName ?? g?.name,
            }));
        return {
            isLoading: !raw && !error,
            displayName,
            email,
            metadataRows,
            listTitle,
            listItems,
        };
    }, [raw, error, orgNameMap, isClusterAdmin, t]);
    return userDetailsProps;
};
//# sourceMappingURL=useUserDetails.js.map